/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Mock_F3Inputs */

const en_cp_mock_f3 = /** @type {(inputs: Cp_Mock_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily report for the clinic head`)
};

const id_cp_mock_f3 = /** @type {(inputs: Cp_Mock_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan harian kepala puskesmas`)
};

/**
* | output |
* | --- |
* | "Daily report for the clinic head" |
*
* @param {Cp_Mock_F3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_mock_f3 = /** @type {((inputs?: Cp_Mock_F3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Mock_F3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_mock_f3(inputs)
	return en_cp_mock_f3(inputs)
});